import React, { useState, useEffect, useCallback, useRef } from 'react';
import { FiSearch, FiAlertTriangle, FiPackage, FiX } from 'react-icons/fi';
import api from '../services/api';
import '../styles/Inventarios.css';

const fmtStock = (n) => {
  const v = parseFloat(n);
  if (isNaN(v) || v === 0) return '0';
  return v % 1 === 0 ? String(v) : v.toFixed(2);
};

export default function StockPage() {
  const [data,       setData]      = useState({ almacenes: [], productos: [] });
  const [loading,    setLoading]   = useState(true);
  const [error,      setError]     = useState('');
  const [search,     setSearch]    = useState('');
  const [soloBajo,   setSoloBajo]  = useState(false);
  const timer = useRef(null);

  const load = useCallback(async (q = '', bajo = false) => {
    setLoading(true); setError('');
    try {
      const r = await api.get('/api/almacenes/stock/consolidado', { params: { q } });
      let prods = r.data.productos || [];
      if (bajo) prods = prods.filter(p => parseFloat(p.total) < parseFloat(p.stock_minimo) && parseFloat(p.stock_minimo) > 0);
      setData({ almacenes: r.data.almacenes || [], productos: prods });
    } catch (e) { setError(e.response?.data?.error || e.message); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleSearch = (v) => {
    setSearch(v);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => load(v, soloBajo), 300);
  };

  const handleBajo = (v) => {
    setSoloBajo(v);
    load(search, v);
  };

  const { almacenes, productos } = data;

  return (
    <div className="inv-page">
      <div className="inv-toolbar">
        <div className="inv-search-bar">
          <FiSearch size={13} />
          <input placeholder="Buscar producto..."
            value={search} onChange={e => handleSearch(e.target.value)} />
          {search && <button className="inv-clear-search" onClick={() => handleSearch('')}><FiX size={12}/></button>}
        </div>
        <label className="inv-check-label">
          <input type="checkbox" checked={soloBajo} onChange={e => handleBajo(e.target.checked)} />
          Solo bajo mínimo
        </label>
      </div>

      {loading ? <div className="inv-loading">Cargando stock...</div>
       : error   ? <div className="inv-error">{error}</div>
       : productos.length === 0 ? (
          <div className="inv-empty-center">
            <FiPackage size={36} />
            <p>{search ? 'Sin resultados' : 'Sin productos registrados'}</p>
          </div>
        ) : (
        <div className="inv-table-wrap">
          <table className="inv-table inv-table-stock">
            <thead>
              <tr>
                <th>Código</th>
                <th>Producto</th>
                <th>Familia</th>
                <th>Unidad</th>
                {almacenes.map(a => <th key={a.id} className="inv-th-alm">{a.nombre}</th>)}
                <th className="inv-th-total">TOTAL</th>
                <th className="inv-th-min">Mín.</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {productos.map((p, i) => {
                const total   = parseFloat(p.total) || 0;
                const minimo  = parseFloat(p.stock_minimo) || 0;
                const bajoMin = minimo > 0 && total < minimo;
                const sinStk  = total === 0;
                return (
                  <tr key={p.id} className={`${i%2===0?'inv-row-even':'inv-row-odd'} ${bajoMin?'inv-row-warn':''}`}>
                    <td className="inv-td inv-td-cod">{p.codigo || '—'}</td>
                    <td className="inv-td">
                      <span className="inv-prod-nombre">{p.nombre}</span>
                    </td>
                    <td className="inv-td inv-td-fam">{p.familia_nombre || '—'}</td>
                    <td className="inv-td inv-td-und">{p.unidad_short || p.unidad_nombre || '—'}</td>
                    {almacenes.map(a => {
                      const s = parseFloat(p.por_almacen?.[a.id] || 0);
                      return (
                        <td key={a.id} className="inv-td inv-td-num">
                          {s > 0 ? <span className="inv-stk-val">{fmtStock(s)}</span>
                                 : <span className="inv-stk-zero">0</span>}
                        </td>
                      );
                    })}
                    <td className="inv-td inv-td-total">
                      <span className={`inv-total-badge ${sinStk?'zero':bajoMin?'low':'ok'}`}>
                        {fmtStock(total)}
                      </span>
                    </td>
                    <td className="inv-td inv-td-min">{minimo > 0 ? fmtStock(minimo) : '—'}</td>
                    <td className="inv-td">
                      {sinStk ? (
                        <span className="inv-est-badge zero">SIN STOCK</span>
                      ) : bajoMin ? (
                        <span className="inv-est-badge low"><FiAlertTriangle size={10}/> BAJO</span>
                      ) : (
                        <span className="inv-est-badge ok">OK</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
